(() => {
  'use strict';
  // Presentation-only Releasit Legacy adapter. It never writes native purchase controls.
  if (window.__fijaDentReleasitPresentationV3 || !['/products/fijadent', '/products/fijadent200'].includes(window.location.pathname)) return;
  window.__fijaDentReleasitPresentationV3 = true;

  const config = window.__fijaDentReleasitPresentationConfigV2;
  if (!config || config.productId !== '15423077974312' || config.variantId !== '67886834483496' || !Array.isArray(config.offers) || config.offers.length !== 3) return;
  const EXPECTED = config.offers;
  const MAX_PENDING_ATTEMPTS = 8;
  let pendingAttempts = 0;
  let scheduled = false;

  const text = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const insertAfter = (reference, node) => reference.parentNode.insertBefore(node, reference.nextSibling);

  // Offer order is the audited Releasit contract. Radio values are intentionally ignored.
  const contractFor = modal => {
    const offers = [...modal.querySelectorAll('._rsi-quantity-offers-offer-container')];
    if (offers.length !== 3) return { status: 'pending' };
    const selected = offers.findIndex(offer => offer.classList.contains('_rsi-quantity-offers-selected'));
    if (selected < 0) return { status: 'pending' };
    const offer = offers[selected];
    const expected = EXPECTED[selected];
    const quantity = offer.querySelector('input[name^="item_quantity"]');
    const variant = offer.querySelector('input[name^="item_variant_id"]');
    const offerId = modal.querySelector('input[name="metrics_quantity_offer_id"]');
    // Legacy keeps variant/quantity hidden inputs only on the selected card; its offer ID is modal-scoped.
    // Do not inspect unselected cards or write any native field.
    if (!quantity || !variant || !offerId) return { status: 'pending' };
    if (quantity.value !== String(expected.qty) || variant.value !== config.variantId || offerId.value !== String(config.offerId)) return { status: 'mismatch' };
    return { status: 'ready', offers };
  };

  const header = (modal, offersBlock) => {
    let block = modal.querySelector('[data-fd-releasit-header]');
    if (!block) {
      block = document.createElement('section');
      block.dataset.fdReleasitHeader = 'true';
      block.className = 'fd-releasit-header';
      block.innerHTML = '<p>OFERTA 2x1: PAGA 1 Y RECIBE 2</p><div class="fd-releasit-intro"><strong>Recibe 2 tubos de 30 g de FijaDent por $79.900 COP en total.</strong><span>Envío incluido y pago contraentrega. Pagas cuando recibes tu pedido.</span><span>Selecciona tu oferta y completa los datos de entrega.</span></div><div class="fd-releasit-status">2x1 vigente — pide hoy y paga cuando recibas</div>';
      offersBlock.parentNode.insertBefore(block, offersBlock);
    }
    [...modal.querySelectorAll('._rsi-custom-text-field')]
      .filter(node => /^(?:1\s*-?\s*elige|completa\s+tu\s+orden\s+aqu[ií])/i.test(node.textContent.trim()))
      .forEach(node => { if (!node.hidden) node.hidden = true; });
  };

  const presentationLayout = () => {
    if (document.getElementById('fd-releasit-v3-alignment-font')) return;
    const style = document.createElement('style');
    style.id = 'fd-releasit-v3-alignment-font';
    style.textContent = '#_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-info,#_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-title,#_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-plaque,#_rsi-cod-form-modal[data-fd-releasit-presentation="true"] .fd-releasit-detail{text-align:left!important}#_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-info{min-width:0!important;align-items:flex-start!important}#_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-offer-container._rsi-quantity-offers-selected ._rsi-quantity-offers-info{transform:translateX(-2px)}#_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-offer-container._rsi-quantity-offers-selected ._rsi-quantity-offers-prices{transform:translateX(2px)}#_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-prices,#_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-old-price,#_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-new-price{text-align:right!important}#_rsi-cod-form-modal[data-fd-releasit-presentation="true"] [data-fd-releasit-delivery] h3{font-family:Poppins,sans-serif!important;font-size:17.388px!important;font-weight:600!important;font-style:normal!important;line-height:1.3!important;text-align:center!important}@media(max-width:480px){#_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-offer{display:grid!important;grid-template-columns:3.375rem minmax(0,1fr) clamp(6.8rem,34vw,8.35rem)!important;grid-template-areas:"image info prices"!important;align-items:center!important;column-gap:.4rem!important;row-gap:0!important}#_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-modal-line-item-image-container{grid-area:image!important;width:3.375rem!important;height:3.375rem!important;min-width:3.375rem!important;flex-basis:3.375rem!important}#_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-info{grid-area:info!important;width:auto!important;min-width:0!important}#_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-prices{grid-area:prices!important;display:flex!important;flex:0 1 auto!important;flex-direction:column!important;align-items:flex-end!important;justify-content:center!important;justify-self:end!important;width:100%!important;min-width:0!important;max-width:none!important;margin:0!important}#_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-old-price,#_rsi-cod-form-modal[data-fd-releasit-presentation="true"] ._rsi-quantity-offers-new-price{min-width:0!important;max-width:100%!important;white-space:normal!important;overflow-wrap:normal!important;word-break:normal!important;text-align:right!important;line-height:1.15!important}}';
    document.head.appendChild(style);
  };

  const normalizePrice = (offer, expected) => {
    const oldNative = expected.qty === 2 ? '$159.800 COP' : expected.qty === 4 ? '$319.600 COP' : expected.qty === 6 ? '$479.400 COP' : null;
    const oldDisplay = expected.qty === 2 ? '' : expected.old;
    if (oldNative) {
      const walker = document.createTreeWalker(offer, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => { if (node.nodeValue.includes(oldNative)) node.nodeValue = node.nodeValue.replaceAll(oldNative, oldDisplay); });
    }
    offer.querySelectorAll('[data-fd-releasit-display-only]').forEach(node => node.remove());
  };

  const applyOffer = (offer, expected) => {
    const title = offer.querySelector('._rsi-quantity-offers-title');
    const plaque = offer.querySelector('._rsi-quantity-offers-plaque');
    if (!title || !plaque) return;
    text(title, expected.title);
    text(plaque, expected.plaque);
    let detail = offer.querySelector('[data-fd-releasit-detail]');
    if (!detail) {
      detail = document.createElement('div');
      detail.dataset.fdReleasitDetail = 'true';
      detail.className = 'fd-releasit-detail';
      insertAfter(plaque, detail);
    }
    text(detail, expected.detail);
    normalizePrice(offer, expected);
  };

  const delivery = (modal, offersBlock) => {
    let block = modal.querySelector('[data-fd-releasit-delivery]');
    if (!block) {
      block = document.createElement('section');
      block.dataset.fdReleasitDelivery = 'true';
      block.className = 'fd-releasit-delivery';
      block.innerHTML = '<h3>2 - Completa tus datos de entrega</h3><p>Te contactaremos por WhatsApp para confirmar el pedido.</p>';
      insertAfter(offersBlock, block);
    }
    const nativeHeading = [...modal.querySelectorAll('._rsi-custom-text-field')].find(node => /^2\s*-\s*completa/i.test(node.textContent.trim()));
    if (nativeHeading && !nativeHeading.hidden) nativeHeading.hidden = true;
  };

  const enhance = modal => {
    const offersBlock = modal.querySelector('._rsi-quantity-offers');
    if (!offersBlock) return 'pending';
    const contract = contractFor(modal);
    if (contract.status !== 'ready') return contract.status;
    modal.dataset.fdReleasitPresentation = 'true';
    presentationLayout();
    header(modal, offersBlock);
    contract.offers.forEach((offer, index) => applyOffer(offer, EXPECTED[index]));
    delivery(modal, offersBlock);
    return 'ready';
  };

  const schedule = (delay = 0) => {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(() => {
      scheduled = false;
      const modal = document.querySelector('#_rsi-cod-form-modal');
      if (!modal) return;
      const result = enhance(modal);
      if (result === 'pending' && pendingAttempts < MAX_PENDING_ATTEMPTS) {
        pendingAttempts += 1;
        schedule(500);
      }
    }, delay);
  };

  new MutationObserver(mutations => {
    const relevant = mutations.some(mutation => mutation.target?.nodeType === Node.ELEMENT_NODE && (
      mutation.target.closest('#_rsi-cod-form-modal') ||
      [...mutation.addedNodes].some(node => node.nodeType === Node.ELEMENT_NODE && (node.id === '_rsi-cod-form-modal' || node.querySelector?.('#_rsi-cod-form-modal')))
    ));
    if (relevant) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();
